import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HelperService } from 'src/app/services/helper.service';

@Component({
  selector: 'app-spinner-wheel',
  templateUrl: './spinner-wheel.component.html',
  styleUrls: ['./spinner-wheel.component.css']
})
export class SpinnerWheelComponent implements OnInit, OnDestroy {

  isLoading$: boolean;
  subscription: Subscription;
  constructor(
    private helperService: HelperService
  ) { }


  ngOnInit() {
    this.subscription = this.helperService.getLoader().subscribe((value: boolean) => {
      this.isLoading$ = value;
    })
  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

}

